/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-anonymous-default-export */
import React, { useEffect, useState } from "react";
import { Alert, Button, Spin, PageHeader, Layout, Space, Result } from "antd";
import { Formik } from "formik";
import { onecodeAPI } from "../AppConfig";
import { createYupSchema } from "./yupSchemaCreator";
import { useCookies } from "react-cookie";
import _ from "lodash";
import * as Yup from "yup";
import uuid from "react-uuid";
import TextInput from "./TextInput";
import Top from "../lf3/Top";
import "antd/dist/antd.css";
import { Checkbox } from "antd";
import { Card } from "antd";
// import { Select } from "antd";
import { Row, Col } from "antd";
// const { Option } = Select;
import NotEligible from "../lf3/NotEligible";
import { Redirect } from "react-router";
import Modal from "antd/lib/modal/Modal";
import { CloseOutlined } from "@ant-design/icons/lib/icons";
import SelectInput from "./SelectInput";
import CustomerForm from "../PANRecommendations/CustomerForm";
import { Email } from "@mui/icons-material";

import DatePick from "./DatePick";
import SearchInput from "./SearchInput";
import ContentModal from "./ContentModal";
import ApplyModal from "../PANRecommendations/ApplyModal";
export default function () {
  const [formData, setFormData] = useState([]);
  const [partnerId, setPartnerId] = useState("");
  const [desc, setDesc] = useState("");
  const [loading, setLoading] = useState(true);
  const { Header, Content, Footer } = Layout;
  const [message, setMessage] = useState("");
  const [cookies, setCookie] = useCookies(["partnerId"]);
  const [ocDeviceId, setOcuuid] = useState(uuid());
  const [categoryId, setCategoryId] = useState("");

  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [pincode, setPincode] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [mailId, setMailId] = useState("");
  const [customerName, setCustomerName] = useState(null);
  const [panNo, setPanNo] = useState("");

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [agree, setAgree] = useState(true);
  const [onecode, setOnecode] = useState(null);
  const [isRupeekModalVisible, setIsRupeekModalVisible] = useState(false);
  const [handelContentModal, setHandelContentModal] = useState(false);
  const [responsePopContent, setResponsePopContent] = useState({
    heading: "",
    description: "",
    link:""
  });
  const [leadSource, setLeadSource] = useState(null);
  const [applyModalPopup,setApplyModalPopup] = useState(false);
  const [partnerLink, setPartnerLink] = useState("");
  const [responseStatus, setResponseStatus] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [partnerDetails,setPartnerDetails] = useState({
    id:"",
    title:""
  })
  const [customerObj,setCustomerObj]= useState({
    fullName:"",
    customerName:"",
    phoneNumber:""
  })
  const [brandNotEligibleReasons, setBrandNotEligibleReasons] = useState([]);
  // const [responsePopContent, setResponsePopContent] = useState({});
  // const [fieldCode, setFieldCode] = useState([]);
  const fieldCode = [];
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showRupeekModal = () => {
    setIsRupeekModalVisible(true);
  };
  const handleRupeekOk = () => {
    setIsRupeekModalVisible(false);
  };

  const handleRupeekCancel = () => {
    setIsRupeekModalVisible(false);
  };

  const handleApplyModalCancel = () => {
    setApplyModalPopup(false);
  };

  let params = new URLSearchParams(window.location.search);

  // console.log(window.location.pathname, "paramsparams");

  let hash = params.get("hash");
  // hash = hash.replaceAll(" ","+")
  // hash = encodeURIComponent(hash);

  let pathName = window.location.pathname;
  let pathNameWithoutSlash = pathName.replace(/\//g, "");
  // let buff = new Buffer(hash, "base64");
  // let base64ToString = JSON.parse(buff.toString());

  // let params = new URLSearchParams(window.location.search);
  // let hash= params.get('token');

  useEffect(() => {
    getFormData();
  }, []);

  useEffect(() => {
    if (onecode && partnerId && partnerName) {
      window?.Moengage?.track_event("lf4_page_view", {
        onecode: onecode,
        id: partnerId,
        brand_name: partnerName,
        // brand_category:,
        // category-level-brand_name:
      });
    }
  }, [onecode, partnerId, partnerName]);

  let urlencode = encodeURIComponent(hash);
  const getFormData = async () => {
    setLoading(true);
    let getFormData = [];
    let response;
    try {
      if (pathNameWithoutSlash == "v4") {
        response = await onecodeAPI.post(`/partnerForm/findByPartner/v6`, {
          // response = await onecodeAPI.post(`/partnerForm/findByPartner/v4`, {
          hash: urlencode,
        });
      } else {
        response = await onecodeAPI.get(
          `/partnerForm/findByPartner?hash=${hash}`
        );
      }
      let brandUrl = _.get(response, "data.data.url");
      let isEligible = _.get(response, "data.data.isEligible");

      let onecode = _.get(response, "data.data.onecode");
      window?.Moengage?.add_unique_user_id(onecode);

      setOnecode(onecode);

      let name = _.get(response, "data.data.fullname");
      setFullName(name);

      const customerFullname = _.get(response, "data.data.customerName");
      setCustomerName(customerFullname);

      let mobileNumber = _.get(response, "data.data.customerPhoneNumber");
      setPhoneNumber(mobileNumber);

      let leadaddedSource = _.get(response, "data.data.leadSource");
      setLeadSource(leadaddedSource);

      let custId = _.get(response, "data.data.customerId");
      setCustomerId(custId);

      setCustomerObj({
        fullName:customerFullname,
    customerName:customerFullname,
    phoneNumber:mobileNumber
      })

      let partnerName = _.get(
        response,
        "data.data.partnerForms[0].partnerName"
      );
      setPartnerName(partnerName);

      let mailId = _.get(response, "data.data.email");
      setMailId(mailId);
      let pincode = _.get(response, "data.data.pincode");
      setPincode(pincode);

      let panNo = _.get(response, "data.data.panNo");
      setPanNo(panNo);

      if (
        _.has(response.data, "message") &&
        _.has(response.data, "partnerId")
      ) {
        // console.log(response);
        setMessage(response.data.message);
        setPartnerId(response.data.partnerId);
        setCategoryId(response.data?.partnerCategoryId);
      }

      getFormData = response.data.data.partnerForms;
      setPartnerId(response.data.data.partnerForms[0].partnerId);
      setCategoryId(response.data.data.partnerForms[0]?.partnerCategoryId);
      setPartnerDetails({
        id:response.data.data.partnerForms[0].partnerId,
        title:partnerName
      })
      
      let description = _.get(
        response,
        "data.data.partnerForms[0].partner.description"
      );
      setDesc(description);
      setFormData(getFormData);
      setLoading(false);
      if (cookies["oc-deviceId"] == undefined) {
        setCookie("oc-deviceId", ocDeviceId, { path: "/" });
      }

      if (_.has(response.data, "data")) {
        getFormData = response.data.data.partnerForms;
        setPartnerId(response.data.data.partnerForms[0].partnerId);
        setCategoryId(response.data.data.partnerForms[0]?.partnerCategoryId);
        let description = _.get(
          response,
          "data.data.partnerForms[0].partner.description"
        );
        setDesc(description);
        setFormData(getFormData);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const initialValues = {};
  formData.length &&
    formData[0].ocForm.ocFieldGroups.forEach((page) => {
      page.ocFields.forEach((item) => {
        if (item.value) {
          initialValues[item.id] = item.value ? item.value : "";
        } else {
          initialValues[item.id] = "";
        }
      });
    });

  let ocFields = [];
  formData.length &&
    formData[0].ocForm.ocFieldGroups.map((page) => {
      ocFields = ocFields.concat(page.ocFields);
    });

  const yepSchema = ocFields.reduce(createYupSchema, {});
  const validationSchema = Yup.object().shape(yepSchema);

  const onSubmit = async (values, error) => {
    setLoading(true);
    let fieldValues = [];

    _.map(values, (value, key) => {
      const code = _.filter(fieldCode, (c) => {
        return c.id == key;
      });
      let fieldValue = {
        ocFieldId: key,
        value: value,
        code: code[0].code,
      };

      fieldValues.push(fieldValue);
    });
    //
    let data = {
      ocPartnerFormId: formData[0].id,
      ocFieldValues: fieldValues,
      deviceId: cookies["oc-deviceId"] || ocDeviceId,
      partnerCategoryId: categoryId,
    };
    let v2Data = {
      ocUserForm: {
        ocPartnerFormId: formData[0].id,
        ocFieldValues: fieldValues,
      },
      deviceId: cookies["oc-deviceId"] || ocDeviceId,
      partnerCategoryId: categoryId,
      hash: urlencode,
      hasOtpCheck: false,
      leadSource:leadSource
    };

    let res;
    try {
      if (pathNameWithoutSlash == "v4") {
        res = await onecodeAPI.post(`/userForm/addLead/v4`, v2Data);
        
      } else {
        res = await onecodeAPI.post(
          `/userForm/addLead?hash=${hash}&hasOtpCheck=false`,
          data
        );
      }
      let brandUrl = _.get(res, "data.data.url");
      let isEligible = _.get(res, "data.data.userForm.isEligible");
      let customerPhoneNumber = _.get(res, "data.data.customerPhoneNumber");
      window?.Moengage?.track_event("lf4_successful_submission", {
        name: fullName,
        email: mailId ? mailId : "",
        brand_name: partnerName,
        customer_name: customerName,
        customer_phone: customerPhoneNumber,
      });
      let statusCode = _.get(res, "data.data.statusCode");
      let dataIssue = _.get(res, `data.data.message`, "");
      let notEligibleReasons = _.get(res, `data.data.message`, []);
      setBrandNotEligibleReasons(notEligibleReasons|| []);
        if (statusCode == 3307) {
          if (res.data?.url) {
            window.open(res?.data?.url);
          }
          return null;
        } else if (statusCode == 3308) {  //field error
          // setEmailHandlePopup(true);
          setLoading(false);
          setHandelContentModal(true);
          setResponsePopContent({
            heading: "Invalid data",
            description: dataIssue ? dataIssue : "",
            link:""
          });

          return null;
        } else if (statusCode == 3309) {  //not eligible
          //  setIsEligibleModalVisible(true);
          setLoading(false);
          setIsModalVisible(true);
          return null;
        } else if (statusCode == 3310) {
          setHandelContentModal(true);
          setResponsePopContent({
            heading: "Server Error",
            description: dataIssue ? dataIssue : "",
          });
        }
      else if (partnerId == 171) {
        showRupeekModal();
      }
      // else if ( leadSource == "app" || leadSource == "appBrand" ){
      //   window.open(`https://app.onecode.in/share/brand/${partnerId}/${customerId}/${leadSource}/${brandUrl}`, "_blank");
      // } 
      else if (brandUrl && !brandUrl.includes("null")) {
        setApplyModalPopup(true);
      setPartnerLink(brandUrl);
        // window.open(brandUrl, "_blank");
      } else {
        alert("Lead Submitted Successfully");
      }

      // let brandUrl = res.data.data.url;
      // let leadID = _.get(res, "data.data.userForm.id");
      // if (brandUrl && !brandUrl.includes("null")) {
      //   // window.location.replace(brandUrl);
      // }
      setLoading(false);
    } catch (err) {
      console.log(err, "err");
      let message = _.get(err, "response.data.message", "Something went wrong");
      let splitErrors = message.split(",");
      if (err?.response?.status == 409) {
        setResponseStatus(err?.response?.status);
        setApplyModalPopup(true);
      }

      let errors = {};
      splitErrors.forEach((id) => {
        errors = { ...errors, [id]: "Details already exist" };
      });

      error.setErrors(errors);
      setLoading(false);
      alert(message);
    }
  };

  const FormData = (formProperties) => {
    // console.log(formProperties, "formProperties");
    let form = [];
    let code = [];
    formData.length &&
      formData[0].ocForm.ocFieldGroups.map((page, pageIndex) => {
        page.ocFields.map((e, index) => {
          // let l = e[index];

          // setCode({ ...code, id: e.id, code: e.code });
          if (e.type === "text") {
            fieldCode.push({ id: e.id, code: e.code });
            form.push(<TextInput {...e} key={index} {...formProperties} />);
          } else if (e.type === "dropdown") {
            fieldCode.push({ id: e.id, code: e.code });
            form.push(<SelectInput {...e} key={index} {...formProperties} />);
          } else if (e.type === "date") {
            fieldCode.push({ id: e.id, code: e.code });
            form.push(<DatePick {...e} key={index} {...formProperties} />);
            // form.push(<SearchInput {...e} key={index} {...formProperties} />);
          }
        });
      });
    return form;
  };

  function onChange(e) {
    setAgree(!agree);
  }

  if (message) {
    return (
      <div style={{ height: "100%" }}>
        {partnerId ? (
          <div
            style={{
              height: "20%",
              justifyContent: "center",
              alignItems: "center",
              flex: 1,
              display: "flex",
              marginTop: 10,
            }}
          >
            <img
              src={
                categoryId
                  ? `https://onecode-asset.s3.ap-south-1.amazonaws.com/${partnerId}_${categoryId}.jpg`
                  : `https://onecode-asset.s3.ap-south-1.amazonaws.com/${partnerId}.jpg`
              }
              style={{ width: "50%", alignItems: "center" }}
            />
          </div>
        ) : (
          <></>
        )}
        <div
          style={{
            height: "80%",
            // marginTop: "50%",
            textAlign: "center",
            justifyContent: "center",
            display: "flex",
            // alignItems: "center",
            fontSize: "25px",
            paddingTop: partnerId ? "100px" : "300px",
          }}
        >
          {message}
        </div>
      </div>
    );
  } else {
    return (
      <Layout className="layout" style={{}}>
        <Top fullName={fullName} phoneNumber={phoneNumber} mailId={mailId} />

        <Content>
          {cookies.partnerLeadSubmissionCount &&
          Number(cookies.partnerLeadSubmissionCount) + 1 > 5 ? (
            <Alert message="You cannot access this page!" type="error" />
          ) : (
            <Spin
              spinning={loading}
              style={{
                flex: 1,
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              {/* <Row style={{textAlign:"center",justifyContent:"center"}}>
        <div style={{}}>
            <div style={{
               textAlign: "center" 
               }}>
            
              {partnerId ? (
                <img
                  src={categoryId ? `https://onecode-asset.s3.ap-south-1.amazonaws.com/${partnerId}_${categoryId}.jpg` : `https://onecode-asset.s3.ap-south-1.amazonaws.com/${partnerId}.jpg`}
                  style={{ width: "35%", 
                  alignItems: "center",
                  textAlign:"center",
                  justifyContent:"center",
                  borderRadius:"10px",
                  marginTop:"20px"
                 
                }}
                />
              ) : (
                <></>
              )}
              <p style={{ fontSize: 12,
                 paddingLeft: 20, 
                 paddingRight: 20 
                 }}>
                {desc}
              </p>
            </div>
            </div>
            </Row>
           */}

              <Card
                style={{
                  color: "#FFFFFF",
                  borderRadius: "10px",
                  marginLeft: "30px",
                  marginRight: "30px",
                  marginTop: "40px",
                }}
              >
                <Row style={{ textAlign: "center", justifyContent: "center" }}>
                  <div style={{}}>
                    <div
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {partnerId ? (
                        <img
                          src={
                            categoryId
                              ? `https://onecode-asset.s3.ap-south-1.amazonaws.com/${partnerId}_${categoryId}.jpg`
                              : `https://onecode-asset.s3.ap-south-1.amazonaws.com/${partnerId}.jpg`
                          }
                          style={{
                            width: "35%",
                            alignItems: "center",
                            textAlign: "center",
                            justifyContent: "center",
                            borderRadius: "10px",
                            marginTop: "-77px",
                            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
                          }}
                        />
                      ) : (
                        <></>
                      )}
                      <p
                        style={{
                          fontSize: 12,
                          paddingLeft: 20,
                          paddingRight: 20,
                        }}
                      >
                        {desc}
                      </p>
                    </div>
                  </div>
                </Row>

                <div style={{ textAlign: "center", marginTop: "-25px" }}>
                  <Col
                    style={{
                      color: "#000000",
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    Hey {customerName}!
                  </Col>
                  <Col style={{ color: "#8C8C8C" }}>
                    Please check your eligibility for {partnerName}
                  </Col>
                </div>

                {formData != null && formData.length > 0 ? (
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    // onSubmit={onSubmit}
                    onSubmit={onSubmit}
                    validateOnBlur={true}
                    validateOnChange={true}
                    enableReinitialize
                  >
                    {({
                      handleSubmit,
                      handleChange,
                      handleBlur,
                      values,
                      errors,
                      isValid,
                      touched,
                      setValues,
                      setTouched,
                      resetForm,
                    }) => (
                      <div style={{ marginTop: 20, textAlign: "center" }}>
                        <FormData
                          handleChange={handleChange}
                          values={values}
                          handleBlur={handleBlur}
                          errors={errors}
                          touched={touched}
                          setValues={setValues}
                          setTouched={setTouched}
                        />

                        <div style={{ marginTop: "40px" }}>
                          {partnerId == 171 ? (
                            <Checkbox
                              checked={true}
                              style={{ fontSize: "12px", color: "#8C8C8C" }}
                            >
                              I am interested to submit my gold as a collateral
                              for a secure loan
                            </Checkbox>
                          ) : (
                            <></>
                          )}
                          <Checkbox
                            checked={agree}
                            onClick={() => {
                              window?.Moengage?.track_event(
                                "lf4_termsofuseprivacypolicy_check"
                              );
                            }}
                            onChange={onChange}
                            style={{ fontSize: "12px", color: "#8C8C8C" }}
                          >
                            Agree{" "}
                            <a
                              onClick={() => {
                                window?.Moengage?.track_event(
                                  "lf4_termsofuse_click"
                                );
                              }}
                              href="https://onecode-asset.s3.ap-south-1.amazonaws.com/Web+site-T%26C-Policies/EndUsersEULA-OneCode.html"
                              style={{ color: "#6C63FF", fontWeight: "500px" }}
                            >
                              Terms of use
                            </a>{" "}
                            &
                            <a
                              onClick={() => {
                                window?.Moengage?.track_event(
                                  "lf4_privacypolicy_click"
                                );
                              }}
                              href="https://onecode-asset.s3.ap-south-1.amazonaws.com/Web+site-T%26C-Policies/EndUsersPrivacyPolicy-OneCode+.html"
                              style={{ color: "#6C63FF", fontWeight: "500px" }}
                            >
                              {" "}
                              Privacy Policy
                            </a>
                          </Checkbox>
                        </div>

                        <div style={{ textAlign: "center" }}>
                          <Button
                            style={{
                              minWidth: 250,
                              padding: 8,
                              borderRadius: 5,
                              height: 40,
                              backgroundColor: agree ? "#6c63ff" : "#c2c2c2",
                              color: "#fff",
                              marginTop: 20,
                              borderColor: agree ? "#6c63ff" : "#c2c2c2",
                              borderWidth: 1,
                            }}
                            disabled={!agree}
                            onClick={handleSubmit}
                          >
                            Continue
                          </Button>
                        </div>
                      </div>
                    )}
                  </Formik>
                ) : (
                  <Result
                    status="404"
                    title="404"
                    subTitle="Sorry, the page you visited does not exist."
                  />
                )}
              </Card>
            </Spin>
          )}
          {isModalVisible && (
            <Modal
              visible={isModalVisible}
              // width="335px"
              // onCancel={handleCancel}
              footer={null}
              centered={true}
              closable={false}
              keyboard={true}
              mask={true}
              maskClosable={true}
              closeIcon={
                <CloseOutlined
                  style={{
                    fontSize: "7px",
                    marginTop: "10px",
                  }}
                  onOk={handleOk}
                  className="modalCloseBtn"
                />
              }
            >
              <NotEligible brandNotEligibleReasons={brandNotEligibleReasons} partnerName={partnerName} />
            </Modal>
          )}
          {handelContentModal && (
            <ContentModal
              modalVisible={handelContentModal}
              popupContent={responsePopContent}
              setHandelContentModal={setHandelContentModal}
              // popupContent={"suupppp"}
            />
          )}
          <Modal
            visible={isRupeekModalVisible}
            // width="335px"
            // onCancel={handleCancel}
            footer={null}
            centered={true}
            closable={false}
            keyboard={true}
            mask={true}
            maskClosable={true}
            closeIcon={
              <CloseOutlined
                style={{
                  fontSize: "7px",
                  marginTop: "10px",
                }}
                onOk={handleRupeekOk}
                className="modalCloseBtn"
              />
            }
          >
            <p style={{ textAlign: "center", fontWeight: "bold" }}>
              Lead has been created successfully!
            </p>
            <p style={{ textAlign: "center" }}>
              Rupeek Gold Loan team will contact the customer regarding further
              process.
            </p>
          </Modal>
          <ApplyModal
          isModalVisible={applyModalPopup}
          handleCancel={handleApplyModalCancel}
          responseStatus={responseStatus}
          partnerDetails={partnerDetails}
          setIsModalVisible={setApplyModalPopup}
          customer={customerObj}
          buttonToDisplay={"whatsapp"}	
          partnerLink={partnerLink}
      />
        </Content>
      </Layout>
    );
  }
}
